import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import _debug from 'debug';
import configureStore from 'common/redux/configureStore';
import MaintenanceList from './components/MaintenanceList';
import CompanySelect from './components/CompanySelect';
import { Provider } from 'react-redux';
import { fetchJson } from 'utils/fetch';
import * as AdminApi from './api';
import moment from 'moment';
import 'moment';
import 'vendors/semantic-daterangepicker/daterangepicker';

const debug = _debug('app::control-panel');

export function index() {
  debug('Rendering control panels');
  const token = window.__ADMIN_TOKEN__;
  if (token) {
    ReactDOM.render(
      <MaintenanceList token={token} />,
      document.getElementById('maintenances-root')
    );
  }
}

export function user() {
  const $dropdown = $('input[name=tags]').closest('.dropdown');
  $dropdown.dropdown({
    allowAdditions: true,
    direction: 'upward',
  });
  $dropdown.on('keypress', evt => {
    if (evt.keyCode === 13) {
      evt.preventDefault();
    }
  });

  const root = document.getElementById('company-select');
  const store = configureStore();
  ReactDOM.render(
    <Provider store={store}>
      <CompanySelect
        label={root.getAttribute('data-label')}
        value={root.getAttribute('data-value')}
      />
    </Provider>,
    root
  );
}

export function mailing() {
  const $customers = $('#CustomerSelect');
  const $noCustomer = $('#NoCustomer');
  const $saveButton = $customers.closest('form').find('button[type="submit"]');

  $('#LookupCustomer').on('click', event => {
    const $button = $(event.currentTarget);

    $noCustomer.hide();
    $customers.closest('.field').hide();
    $saveButton.addClass('disabled');

    const email = $button
      .closest('.field')
      .find('input')
      .val();
    $button.addClass('loading');

    fetchJson(`/admin/mailing/customers?email=${email}`)
      .then(customers => {
        $button.removeClass('loading');

        if (customers.length > 0) {
          customers
            .map(c => `<option value="${c.id}">${c.name}</option>`)
            .forEach(option => $customers.append(option));

          $customers.closest('.field').show();
          $saveButton.removeClass('disabled');
        } else {
          $noCustomer.show();
        }
      })
      .catch(_ => {
        $button.removeClass('loading');
        window.alert('User not found');
      });
  });
}

export function access() {
  const $entityDropdown = $('.customer_entity.dropdown');
  const $customerUserDropdown = $('.customer_user.dropdown');
  const $customerUserDropdownField = $customerUserDropdown.parent('.field');

  if (
    $entityDropdown &&
    $entityDropdown.length &&
    $customerUserDropdown &&
    $customerUserDropdown.length
  ) {
    $customerUserDropdownField.addClass('disabled');
    $entityDropdown.dropdown({
      onChange: evt => {
        AdminApi.getByEntityId(evt).then(json => {
          $customerUserDropdownField.removeClass('disabled');
          $customerUserDropdown.dropdown('clear');
          $customerUserDropdown.dropdown('setup menu', { values: json });
        });
      },
    });
  }
}

export function exports() {
  $.fn.datepicker.dates['fr'] = {
    days: [
      'Dimanche',
      'Lundi',
      'Mardi',
      'Mercredi',
      'Jeudi',
      'Vendredi',
      'Samedi',
    ],
    daysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    daysMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    months: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Saptembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ],
    monthsShort: [
      'Jan',
      'Fev',
      'Mar',
      'Avr',
      'Mai',
      'Jui',
      'Juil',
      'Aou',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    today: "Aujourd'hui",
    clear: 'Effacer',
    format: 'dd/mm/yyyy',
    titleFormat: 'MM yyyy',
    weekStart: 1,
  };

  const startDate = moment()
    .subtract(1, 'months')
    .startOf('month');
  const endDate = moment()
    .subtract(1, 'months')
    .endOf('month');

  $('input.datepicker').datepicker({
    language: 'fr',
    autoclose: true,
    orientation: 'bottom',
  });

  // DateRange
  $('input.daterange').daterangepicker({
    language: 'fr',
    format: 'DD/MM/YY',
    opens: 'right',
    startDate: startDate,
    endDate: endDate,
    locale: {
      applyLabel: 'Appliquer',
      cancelLabel: 'Fermer',
      fromLabel: 'De',
      toLabel: 'à',
      weekLabel: 'S',
      customRangeLabel: 'Période personnalisée',
      daysOfWeek: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
      monthNames: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
        '_'
      ),
      firstDay: 1,
    },
  });

  $('.daterange.selectionInput').val(
    startDate.format('DD/MM/YY') + ' - ' + endDate.format('DD/MM/YY')
  );
}



// WEBPACK FOOTER //
// ./src/modules/admin/index.js